export enum CardTitle {
  oil_production = 'Oil Production (BBL/d)',
  gas_injection = 'Gas injection Rate (Ksm3/d)',
  water_injection = 'Water injection (Sm3/d)',
  flaring = 'Flaring (Ksm3/d)',
  liquid_production='Liquid Production (BBL/d)',
  gas_production='Gas Production (kSm3/d)'
}
